import React from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      category: "Vertragsrecht",
      situation: "Problematischer Kaufvertrag",
      challenge: "Unklare Klauseln in einem Immobilienkaufvertrag führten zu Unsicherheiten über Gewährleistungsansprüche.",
      solution: "Detaillierte Analyse der Vertragsklauseln und Aufklärung über Rechte und Pflichten beider Parteien.",
      outcome: "Erfolgreiche Verhandlung mit dem Verkäufer und Anpassung problematischer Klauseln.",
      timeframe: "Beratung: 25 Minuten",
      satisfaction: 5,
      quote: `Die Beratung war strukturiert und verständlich. Ich fühlte mich nach dem Gespräch viel sicherer und wusste genau, wie ich vorgehen sollte.`,
      clientType: "Privatperson",
      region: "Hessen"
    },
    {
      id: 2,
      category: "Arbeitsrecht",
      situation: "Kündigung während Krankheit",
      challenge: "Erhalt einer Kündigung während längerer Krankschreibung - Unsicherheit über Rechtmäßigkeit.",
      solution: "Prüfung der Kündigungsvoraussetzungen und Aufklärung über Kündigungsschutz bei Krankheit.",
      outcome: "Kündigung war unwirksam - erfolgreiche außergerichtliche Einigung mit dem Arbeitgeber.",
      timeframe: "Beratung: 18 Minuten",
      satisfaction: 5,
      quote: `Ohne die schnelle Hilfe von AdvoCall hätte ich wahrscheinlich die Kündigung akzeptiert. Die Beratung hat mir Mut gemacht, für meine Rechte einzustehen.`,
      clientType: "Angestellter",
      region: "Bayern"
    },
    {
      id: 3,
      category: "Mietrecht",
      situation: "Mieterhöhung und Nebenkosten",
      challenge: "Vermieter forderte drastische Mieterhöhung und unklare Nebenkostenabrechnungen.",
      solution: "Überprüfung der Mieterhöhung auf Rechtmäßigkeit und Analyse der Nebenkostenabrechnung.",
      outcome: "Mieterhöhung war teilweise unberechtigt - Reduzierung um 40% erreicht.",
      timeframe: "Beratung: 22 Minuten",
      satisfaction: 5,
      quote: `Die Anwältin erklärte mir Schritt für Schritt, welche Rechte ich als Mieter habe. Das Gespräch war sehr professionell und hat mir viel Geld gespart.`,
      clientType: "Mieter",
      region: "Nordrhein-Westfalen"
    },
    {
      id: 4,
      category: "Familienrecht",
      situation: "Sorgerecht nach Trennung",
      challenge: "Uneinigkeit über Sorgerecht und Umgangsregelung nach Trennung vom Partner.",
      solution: "Aufklärung über Sorgerechtsbestimmungen und Entwicklung einer einvernehmlichen Lösung.",
      outcome: "Gemeinsames Sorgerecht mit fairer Umgangsregelung vereinbart.",
      timeframe: "Beratung: 35 Minuten",
      satisfaction: 5,
      quote: `In einer sehr emotionalen Situation bekam ich sachliche und einfühlsame Beratung. Die Lösung war für alle Beteiligten, besonders für unser Kind, die beste.`,
      clientType: "Elternteil",
      region: "Baden-Württemberg"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "#FCD34D" : "#E5E7EB"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  return (
    <section className="py-16 bg-gradient-to-br from-muted to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Erfolgsgeschichten unserer Mandanten
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Anonymisierte Fallbeispiele zeigen, wie unsere telefonische Rechtsberatung konkrete Probleme löst und positive Ergebnisse erzielt.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {testimonials?.map((testimonial) => (
            <div
              key={testimonial?.id}
              className="bg-white rounded-xl p-8 shadow-professional hover:shadow-elevated transition-all duration-300 border border-slate-200"
            >
              {/* Header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-primary bg-opacity-10 rounded-lg">
                    <Icon name="Scale" size={20} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-text-primary">
                      {testimonial?.category}
                    </h3>
                    <p className="text-sm text-text-secondary">
                      {testimonial?.situation}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-1">
                  {renderStars(testimonial?.satisfaction)}
                </div>
              </div>

              {/* Case Details */}
              <div className="space-y-4 mb-6">
                <div>
                  <h4 className="font-medium text-text-primary mb-2 flex items-center space-x-2">
                    <Icon name="AlertCircle" size={16} className="text-warning" />
                    <span>Ausgangssituation</span>
                  </h4>
                  <p className="text-text-secondary text-sm leading-relaxed">
                    {testimonial?.challenge}
                  </p>
                </div>

                <div>
                  <h4 className="font-medium text-text-primary mb-2 flex items-center space-x-2">
                    <Icon name="Lightbulb" size={16} className="text-accent" />
                    <span>Unsere Beratung</span>
                  </h4>
                  <p className="text-text-secondary text-sm leading-relaxed">
                    {testimonial?.solution}
                  </p>
                </div>

                <div>
                  <h4 className="font-medium text-text-primary mb-2 flex items-center space-x-2">
                    <Icon name="CheckCircle" size={16} className="text-trust-builder" />
                    <span>Ergebnis</span>
                  </h4>
                  <p className="text-text-secondary text-sm leading-relaxed">
                    {testimonial?.outcome}
                  </p>
                </div>
              </div>

              {/* Quote */}
              <div className="bg-muted rounded-lg p-4 mb-6">
                <div className="flex items-start space-x-3">
                  <Icon name="Quote" size={20} className="text-primary mt-1 flex-shrink-0" />
                  <p className="text-text-secondary italic leading-relaxed">
                    {testimonial?.quote}
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                <div className="flex items-center space-x-4 text-sm text-text-secondary">
                  <span>{testimonial?.clientType}</span>
                  <span>•</span>
                  <span>{testimonial?.region}</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-text-secondary">
                  <Icon name="Clock" size={14} />
                  <span>{testimonial?.timeframe}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Privacy Notice */}
        <div className="mt-12 bg-white rounded-xl p-6 border border-slate-200">
          <div className="flex items-start space-x-3">
            <Icon name="Lock" size={20} className="text-primary mt-1 flex-shrink-0" />
            <div>
              <h4 className="font-semibold text-text-primary mb-2">
                Datenschutz und Vertraulichkeit
              </h4>
              <p className="text-text-secondary text-sm leading-relaxed">
                Alle dargestellten Fälle wurden vollständig anonymisiert und mit Zustimmung der Mandanten veröffentlicht. 
                Persönliche Daten, Namen und spezifische Details wurden geändert, um die Privatsphäre zu schützen. 
                Die rechtlichen Sachverhalte und Beratungsergebnisse entsprechen den tatsächlichen Fällen. 
                Unsere anwaltliche Schweigepflicht bleibt in jedem Fall gewahrt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;